"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isApiSellingPlanFixedAmountPriceAdjustment = isApiSellingPlanFixedAmountPriceAdjustment;
exports.isApiSellingPlanFixedPriceAdjustment = isApiSellingPlanFixedPriceAdjustment;
exports.isApiSellingPlanPercentagePriceAdjustment = isApiSellingPlanPercentagePriceAdjustment;
function isApiSellingPlanFixedAmountPriceAdjustment(priceAdjustment) {
    return 'adjustmentAmount' in priceAdjustment;
}
function isApiSellingPlanFixedPriceAdjustment(priceAdjustment) {
    return 'price' in priceAdjustment;
}
function isApiSellingPlanPercentagePriceAdjustment(priceAdjustment) {
    return 'adjustmentPercentage' in priceAdjustment;
}
